// extracted by mini-css-extract-plugin
module.exports = {"colorPickerBox":"ColorPicker_colorPickerBox__N1xcK"};